// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class StorybookUpdate {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(update) {
        this.isFailed = update.isFailed;
        this.docsCount = update.docsCount;
        this.storiesCount = update.storiesCount;
        this.created = update.created;
        this.updated = update.updated;
        this.deleted = update.deleted;
    }
}
